var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5676 0C4.30819 0 0 7.1875 0 7.1875C0 7.1875 4.30819 14.375 11.5676 14.375C18.6832 14.375 23 7.1875 23 7.1875C23 7.1875 18.6832 0 11.5676 0ZM11.5 2.15625C14.3031 2.15625 16.5312 4.38438 16.5312 7.1875C16.5312 9.99063 14.3031 12.2188 11.5 12.2188C8.69687 12.2188 6.46875 9.99063 6.46875 7.1875C6.46875 4.38438 8.69687 2.15625 11.5 2.15625ZM8.625 7.1875C8.625 5.60625 9.91875 4.3125 11.5 4.3125L11.4993 4.31178C11.9305 4.31178 12.2856 4.393 12.645 4.53675C12.3575 4.75238 12.218 5.03125 12.218 5.39062C12.218 5.96563 12.7212 6.46875 13.2962 6.46875C13.6555 6.46875 13.9344 6.32931 14.15 6.04181C14.2938 6.40119 14.375 6.75625 14.375 7.1875C14.375 8.76875 13.0813 10.0625 11.5 10.0625C9.91875 10.0625 8.625 8.76875 8.625 7.1875Z",
    fill: "#424B50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.2cef411e.svg";
export { ForwardRef as ReactComponent };